export default __webpack_public_path__ + "static/media/factors-household-habits.66bb6274.jpg";